import { MutableState } from '../../form';

export const setInitialValue = <T,>([fieldName, newValue]: any[], state: MutableState<T, Partial<T>>) => {

   const { formState } = state;

   if (formState.initialValues === undefined) {
      formState.initialValues = {};
   }
   formState.initialValues[fieldName] = newValue;
};

export const clearSubmitErrors = <T,>(fieldNames: Array<keyof T>, state: MutableState<T, Partial<T>>) => {

   const { formState } = state;

   if (formState.submitErrors !== undefined) {
      for (const fieldName of fieldNames) {
         formState.submitErrors[fieldName] = undefined;
      }
   }
};

export const setFormSubmitting = <T,>([submitting]: any[], state: MutableState<T, Partial<T>>) => {
   const { formState } = state;

   formState.submitting = submitting;
};

export const setSaveErrors = <T,>([saveErrors]: any[], state: MutableState<T, Partial<T>>) => {

   const { formState } = state;

   const keys = Object.keys(saveErrors || {});
   for (const fieldName of keys) {
      if (Object.prototype.hasOwnProperty.call(saveErrors, fieldName)) {
         if (formState.submitErrors === undefined) {
            formState.submitErrors = {};
         }
         formState.submitErrors[fieldName] = saveErrors[fieldName];
      }
   }
};
